import { useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { AdoptionStatsResponse, ApiError } from '../types/showcase';

/**
 * Query: GET /api/eraf/catalog/adoption-stats?days= (queue #687 §UAT-2026-07-14-R687 §R687-2).
 * ROLE_ADMIN 전용 — AdoptionStats.page 가 기간 세그먼트(7/30/0=전체) 전환 시 `days` 를 바꿔
 * 재조회한다. queryKey 에 `days` 를 포함해 기간별로 독립 캐시(§R662 `download-stats` 와 달리
 * 이 조회는 전수/관리 스코프라 실패를 삼키지 않고 ErrorState 로 표면화한다).
 */
export function useAdoptionStats(days: number) {
  return useQuery<AdoptionStatsResponse, ApiError>({
    queryKey: ['adoption-stats', days],
    queryFn: () => showcaseApi.adoptionStats(days),
    retry: false,
    staleTime: 60_000,
  });
}
